import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { ScrollArea } from '~/primitives/scroll-area';
import { defaultClansParams, clansParamsSchema } from './-SearchParams';
import { clansQuery } from '~/util/queries/public/clans';
import { ClansFilters } from './-Filters';
import { ClansTable } from './-ClansTable';

export const Route = createFileRoute('/_authenticated/staff/clans')({
    validateSearch: clansParamsSchema,
    search: {
        middlewares: [stripSearchParams(defaultClansParams)],
    },
    loaderDeps: ({ search: { name_filter, page, per_page } }) => ({
        name_filter,
        page,
        per_page,
    }),
    loader: async ({ context: { queryClient }, deps: filters }) =>
        await queryClient.fetchQuery(clansQuery(filters)),
    component: Users,
    pendingMs: 3000,
});

function Users() {
    return (
        <main className="h-full flex justify-center">
            <div className="flex flex-col p-4 gap-4 size-full bg-background-dark rounded-2xl">
                <ScrollArea className="w-full lg:h-[calc(100vh-150px)]">
                    <h1 className="text-secondary-foreground">Clans</h1>
                    <ClansFilters />
                    <ClansTable />
                </ScrollArea>
            </div>
        </main>
    );
}
